<script setup lang="ts">
import type { AITripDescription } from '../../models';

interface AITripDescriptionProps {
  description: AITripDescription;
}

const props = defineProps<AITripDescriptionProps>();
</script>

<template>
  <div class="ai-trip-description">
    {{ props.description.mainText }}
    <div
      v-for="destination in props.description.destinations"
      :key="destination.name"
    >
      <p class="destination-name">{{ destination.name }}</p>
      <ul>
        <li v-for="(activity, index) in destination.activityTexts" :key="index">
          <div class="activities">
            {{ activity }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ai-trip-description {
  @include font-body-l-light;
  color: var(--color-neutral-70);
  .destination-name {
    @include font-body-m-bold;
  }
  ul {
    padding-inline-start: var(--spacing-24);
    .activities {
      margin-top: var(--spacing-4);
      margin-bottom: var(--spacing-16);
      &:last-child {
        margin-bottom: 0;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
